import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import pdfMake from 'pdfmake/build/pdfmake'
import type { TDocumentDefinitions } from 'pdfmake/interfaces'
import vfs from 'pdfmake/build/vfs_fonts.js'

import {
	TurnoDeVenda,
	FechamentoDeCaixaDetalhado,
} from '@/models'

import print from 'print-js'

window.pdfMake.vfs = vfs.pdfMake.vfs

async function criarDocumentoDeFechamentoDoCaixa(
	turnoDeVenda: TurnoDeVenda,
	fechamentoDeCaixaDetalhado: FechamentoDeCaixaDetalhado,

): Promise<string> {
	
	const dataHoraDoFechamento = fechamentoDeCaixaDetalhado.dataHoraFechamento || new Date()
	const dataHoraDeAbertura = turnoDeVenda.movimentacoes.find(
		({ tipoMovimentacao }) => tipoMovimentacao === 'Abertura',
	)?.dataHoraMovimentacao || ''

	const troco = fechamentoDeCaixaDetalhado.totalEmTrocos
	const cartao = fechamentoDeCaixaDetalhado.itensDeFechamento.find(x => x.forma === 'Cartão')
	const dinheiro = fechamentoDeCaixaDetalhado.totaisPorForma.find(x => x.forma === 'Dinheiro')

	const totalFaturado = fechamentoDeCaixaDetalhado.totalEmVendas

	const valorMovimentacoes =  fechamentoDeCaixaDetalhado.turnoDeVenda.movimentacoes
		.filter(movimentacao => movimentacao.tipoMovimentacao !== 'Abertura').reduce(
			(total, movimentacao) => total + (movimentacao.tipoMovimentacao === 'Sangria' ? movimentacao.valor : movimentacao.valor), 0,
		)

	const valorEsperado = fechamentoDeCaixaDetalhado.totalEsperado
	const totalContado = fechamentoDeCaixaDetalhado.totalContado
	const diferenca = fechamentoDeCaixaDetalhado.totalDeDiferenca

	const docDefinition: TDocumentDefinitions = {
		pageSize: {
			height: 'auto',
			width: 230,
		},

		content: [
			{ text: `Loja ${turnoDeVenda.pontoDeVenda?.loja.nomeFantasia || ''}\n\n`, bold: true, fontSize: 9, alignment: 'center' },
			{ text: `Ponto de Venda ${turnoDeVenda.pontoDeVenda.nome}`, style: 'subHeader' },
			{ text: `Operador ${turnoDeVenda.operador.nome}`, style: 'subHeader' },
			{ text: `Abertura ${dateTimeToPtBrFormat(dataHoraDeAbertura)}`, style: 'subHeader' },
			{ text: `Fechamento ${dateTimeToPtBrFormat(dataHoraDoFechamento)}\n\n`, style: 'subHeader' },

			{ text: 'Resumo\n\n', bold: true, fontSize: 9, alignment: 'center' },
			{
				style: 'tableExample',
				table: {
					body: [
						['Cartão', 'Dinheiro', 'Troco'],
						[`R$ ${JSON.stringify(cartao?.valorContado)}`, `R$ ${JSON.stringify(dinheiro?.valor)}`, `R$ ${JSON.stringify(troco)}\n\n`],

						['Total Faturado', 'Valor Abertura', 'Movimentações'],
						[`R$ ${JSON.stringify(totalFaturado)}`, `R$ ${JSON.stringify(dinheiro?.valor)}`, `R$ ${JSON.stringify(valorMovimentacoes)}\n\n`],

						['Total Esperado', 'Total no Caixa', 'Total de Diferença'],
						[`R$ ${JSON.stringify(valorEsperado)}`, `R$ ${JSON.stringify(totalContado)}`, `R$ ${JSON.stringify(diferenca)}\n\n` ],
					],
				}},
		],

		styles: {
			subHeader: {
				fontSize: 8,
				italics: true,
				alignment: 'center',
			},
		
			title: {
				bold: true,
				fontSize: 6,
				alignment: 'left',
			},

			tableExample:{
				bold: true,
				fontSize: 6,
				alignment: 'center',
			},
		},
	}

	return new Promise(resolve => {
		pdfMake.createPdf(docDefinition).getBase64((result) => resolve(result))
	})
}

export async function imprimirDetalhado(
	turnoDeVenda: TurnoDeVenda,
	fechamentoDeCaixaDetalhado: FechamentoDeCaixaDetalhado,
): Promise<void> {
	const fechamentoDeCaixaBase64: string = await criarDocumentoDeFechamentoDoCaixa(turnoDeVenda, fechamentoDeCaixaDetalhado)
	return new Promise((resolve, reject) => {
		print({
			printable: fechamentoDeCaixaBase64,
			type: 'pdf',
			base64: true,
			onError: reject,
			onLoadingEnd: resolve,
		})
	})
}